var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('router-view'),_c('img',{attrs:{"src":require("../../assets/dragging.png"),"id":"dragImage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }